import { Component } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Component({
  selector: 'app-my-courses',
  templateUrl: './my-courses.component.html',
  styleUrls: ['./my-courses.component.css']
})
export class MyCoursesComponent {
  userId = '';
  constructor(private userService: UserService, private userInfoService: UserInfoService) {
    this.userId = this.userInfoService.getUserId();
  }

  ngOnInit() {
    this.getMyCourses();
  }

  getMyCourses() {
    this.userService.getMyCourses().subscribe((courses: any) => {
      console.log('My Courses:', courses);
    });
  }
}
